import { GlobalProperties } from "./global-properties";

export class GlobalFunctions extends GlobalProperties {


}